import styled, { css } from 'styled-components';
import { LinkText } from '../../typography';
const bottomSheetlinkButtonContainerStyles = ({ theme }) => css `
	cursor: pointer;

	&:hover,
	&:focus {
		color: ${theme.colors.base.textBodyLinkHover};
	}
`;
export const BottomSheetLinkButtonContainer = styled(LinkText) `
	${bottomSheetlinkButtonContainerStyles};
`;
